import type { FC, PropsWithChildren } from "react";
import React from "react";
import { Auth0Provider, type CacheLocation } from "@auth0/auth0-react";
import { isEnv } from "@/helpers/switch.helpers";
import { redirectUri } from "@/helpers/user.helpers";

const domain: string = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId: string = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience: string = import.meta.env.VITE_AUTH0_APP_URI;

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  // Ensure memory caching is used in production envs
  const cacheLocation: CacheLocation = isEnv("local")
    ? "localstorage"
    : "memory";

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      cacheLocation={cacheLocation}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri(),
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthProvider;
